if (!customElements.get('capsule-countdown')) {
  class CapsuleCountdown extends HTMLElement {
    connectedCallback() {
      this.targetTime = Date.parse(this.getAttribute('datetime'));

      if (Number.isNaN(this.targetTime)) {
        return;
      }

      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const remainingSeconds = Math.max(0, Math.floor((this.targetTime - Date.now()) / 1000));
      const hours = Math.floor(remainingSeconds / 3600);
      const minutes = Math.floor((remainingSeconds % 3600) / 60);
      const seconds = remainingSeconds % 60;

      this.textContent = [hours, minutes, seconds]
        .map((unit) => String(unit).padStart(2, '0'))
        .join(':');

      if (remainingSeconds === 0) {
        window.clearInterval(this.interval);
      }
    }
  }

  customElements.define('capsule-countdown', CapsuleCountdown);
}
